import dayjs, { extend, type ConfigType, locale } from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'

extend(relativeTime)
extend(duration)

export type DateType = ConfigType

/**
 * 日期格式
 */
export const DATE_FORMAT = 'YYYY-MM-DD'

/**
 * 日期时间格式
 */
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'

/**
 * 时间格式
 */
export const TIME_FORMAT = 'HH:mm'

/**
 * 设置 dayjs 语言
 */
export const setupDayjsLocale = () => {
  locale('zh-cn')
}

/**
 * 日期格式化
 *
 * @param date 日期
 */
export const formatDate = (date?: DateType, style = DATE_FORMAT) => {
  return dayjs(date).format(style)
}

/**
 * 日期时间格式化
 *
 * @param dateTime 日期时间
 */
export const formatDateTime = (
  dateTime?: DateType,
  style = DATE_TIME_FORMAT
) => {
  return dayjs(dateTime).format(style)
}

/**
 * 时间格式化
 *
 * @param time 时间
 */
export const formatTime = (time?: DateType, style = TIME_FORMAT) => {
  return dayjs(time).format(style)
}
